/**
 * formatCurrency
 * Formats value and currency correctly for the specified locale
 * @param  {string}   locale
 * @param  {string}   currency
 * @param  {number}   amount
 * @return {string}
 */
const formatCurrency = (locale, currency, amount) => {
  if (!amount) {
    return null;
  }

  // If we don't know the currency, just display the amount
  if (!currency) {
    return amount;
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format(amount);
  } catch (e) {
    // If formatting fails, return the amount with currency string appended
    return `${amount} ${currency}`;
  }
};

export default formatCurrency;
